module.exports = "/_next/static/images/favicon.b5b8dd17bf8716ff3ebfa9e744bd2384.png";